import { useContext, useState } from 'react'
import Link from 'next/link'
import BidInput from '../../elements/BidInput/BidInput'
import BidButton from '../../elements/BidButton/BidButton'
import styles from './ForgotPasswordForm.module.scss'
import { AuthContext } from '../../contexts/AuthContext'

export default function ForgotPasswordForm() {
  const [email, setEmail] = useState<any>('')
  const [message, setMessage] = useState<any>(false)
  const [err, setErr] = useState('')
  const { instance } = useContext<any>(AuthContext)

  const handleSubmitEmail = async (e: any) => {
    e.preventDefault()
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
      return setErr('Please enter a valid email.')

    try {
      await instance.get(`/bidder/resendEmailVerification/${email}`)
      setMessage(true)
      setErr('')
    } catch (error: any) {
      setMessage(false)
      const {
        response: {
          data: { message },
        },
      } = error
      setErr(message)
    }
  }

  return (
    <div
      className={`${styles.form_block} mx-auto flex w-full items-center flex-col px-3 md:px-0`}
    >
      <h2
        className={`${styles.forgot_password_title} font-bold max-w-36 md:max-w-none text-center`}
      >
        Re-send Verification E-mail
      </h2>
      <form
        onSubmit={handleSubmitEmail}
        className={`${styles.submit_email} flex flex-col items-center mb-20 md:mb-40 xl:mb-60`}
      >
        <div className="w-full mb-7">
          <BidInput
            inputValue={email}
            setInputValue={setEmail}
            keyDown={handleSubmitEmail}
            theme="blue"
            label="Please enter the e-mail address you registered with"
            labelBold
            placeholder="E-mail Address"
            twcss="text-xs"
          />
        </div>
        {err && (
          <p className="mb-7 text-center" style={{ color: 'red' }}>
            {err}
          </p>
        )}
        {message && (
          <p className="mb-7 text-center">
            Thank you. If the email address submitted is associated with an
            account, you will receive the activation email shortly. If you are
            having trouble activating your account, please reach out to{' '}
            <a
              className="text-bidfta-blue-light"
              href="mailto:support@bidfta.com"
            >
              support@bidfta.com
            </a>
            .
          </p>
        )}
        <div className="w-full mb-7">
          <BidButton
            label="Re-send Verification E-mail"
            theme="blue-light"
            callBack={handleSubmitEmail}
            width="full"
          />
        </div>
        <div className={`${styles.back_to_login} flex mb-7`}>
          <p className="text-bidfta-blue-light cursor-pointer font-semibold">
            <Link href="/account/login" className="underline">
              Back to Login
            </Link>
          </p>
        </div>
        <p className="text-center">
          <span className="font-bold">Note:</span> Please enter your e-mail
          address and click on the “Resend Verification E-mail” button. This
          will send a verfication e-mail with the verification link to the
          e-mail addres you have entered.
        </p>
      </form>
    </div>
  )
}
